import { Component, inject, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SmartCartPreviewStateService } from '@pages/engage/smart-cart/smart-cart-form/preview/smart-cart-preview-state.service';
import { TimerPlacementOption } from '@pages/engage/smart-cart/smart-cart-form/components/timer-config/timer-config.component';
import { TimerPreviewState } from '@pages/engage/smart-cart/smart-cart-form/components/timer-config/timer.model';
import { GoalsProgressBarFormShape } from '../../goals-progress-bar.model';

@Component({
  selector: 'smart-cart-goals-timer-tab',
  templateUrl: './timer-tab.component.html',
  styleUrls: ['../../../../components/shared.scss'],
  standalone: false,
})
export class SmartCartGoalsTimerTabComponent {
  @Input({ required: true }) formGroup!: FormGroup<GoalsProgressBarFormShape>;
  @Input() smartCartId: number | null = null;
  @Input() usageToken = '';

  private readonly previewState = inject(SmartCartPreviewStateService);
  readonly previewTimerState = this.previewState.goalsPreviewTimerState;

  readonly placementOptions: TimerPlacementOption[] = [
    { value: 'inline', text: 'Inline (full width bar)' },
    { value: 'badge', text: 'Badge (icon+text)' },
    { value: 'in_goal_message', text: 'In Goal Message (use {countdown} token to your goal message)' },
  ];

  previewTimer(state: TimerPreviewState): void {
    this.previewState.setGoalsPreviewTimerState(state);
  }
}
